import { useState } from 'react';
import { Overlay } from 'src/components/Overlay';
import { ProxyBanner } from 'src/components/ProxyUser/ProxyUser';
import SingleItem from 'src/layouts/SingleItem';
import { CoReviewInvitation } from './CoReviewInvitation';
import { SubmissionDetails } from './SubmissionDetailsTab';
import { ButtonText } from '@morressier/alembic';
import { Flex } from '@chakra-ui/react';

const CO_REVIEW_INVITATION_TAB = {
  SUBMISSION: 'Submission',
  REVIEW: 'Review'
} as const;

type CoReviewInvitationTab =
  (typeof CO_REVIEW_INVITATION_TAB)[keyof typeof CO_REVIEW_INVITATION_TAB];

const renderTab = (tab: CoReviewInvitationTab) => {
  switch (tab) {
    case CO_REVIEW_INVITATION_TAB.SUBMISSION:
      return <SubmissionDetails />;
    case CO_REVIEW_INVITATION_TAB.REVIEW:
      return <CoReviewInvitation />;
    default:
      return null;
  }
};

export const CoReviewInvitationLayout = ({
  onClose
}: {
  onClose: () => void;
}) => {
  const [activeTab, setActiveTab] = useState<CoReviewInvitationTab>(
    CO_REVIEW_INVITATION_TAB.SUBMISSION
  );

  const filteredTabs = Object.values(CO_REVIEW_INVITATION_TAB);

  return (
    <Overlay>
      <ProxyBanner />
      <SingleItem width="100%">
        <SingleItem.MainArea>
          <SingleItem.Navigation>
            {filteredTabs.map(tab => (
              <SingleItem.Tab
                key={tab}
                onClick={() => setActiveTab(tab)}
                isActive={activeTab === tab}
              >
                {tab}
              </SingleItem.Tab>
            ))}
          </SingleItem.Navigation>
          <SingleItem.Content
            size={activeTab === CO_REVIEW_INVITATION_TAB.REVIEW ? 'large' : 'normal'}
          >
            {' '}
            {renderTab(activeTab)}
          </SingleItem.Content>
        </SingleItem.MainArea>

        <SingleItem.Sidebar>
          <Flex width="100%" flexDirection="column" padding={8} gap={2}>
            <Flex
              paddingX={8}
              margin={4}
              alignItems="center"
              flexDirection="row"
              justifyContent="flex-end"
            >
              <ButtonText onClick={onClose}>Close</ButtonText>
            </Flex>
          </Flex>
        </SingleItem.Sidebar>
      </SingleItem>
    </Overlay>
  );
};
